module.exports = __webpack_public_path__ + "static/hkt1-9dad5bdc435107c7deaf86367c2cfe59.jpg";